import { render, staticRenderFns } from "./CamerasTariffDialog.vue?vue&type=template&id=39859048&"
import script from "./CamerasTariffDialog.vue?vue&type=script&lang=js&"
export * from "./CamerasTariffDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports